"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ApplicationInsightsNotInitializedError = require("./ApplicationInsightsNotInitializedError");
Object.keys(_ApplicationInsightsNotInitializedError).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ApplicationInsightsNotInitializedError[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ApplicationInsightsNotInitializedError[key];
    }
  });
});
var _ApplicationInsights = require("./ApplicationInsights");
Object.keys(_ApplicationInsights).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ApplicationInsights[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ApplicationInsights[key];
    }
  });
});
var _ApplicationInsightsLike = require("./ApplicationInsightsLike");
Object.keys(_ApplicationInsightsLike).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ApplicationInsightsLike[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ApplicationInsightsLike[key];
    }
  });
});
var _getApplicationInsightsReactPlugin = require("./getApplicationInsightsReactPlugin");
Object.keys(_getApplicationInsightsReactPlugin).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getApplicationInsightsReactPlugin[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getApplicationInsightsReactPlugin[key];
    }
  });
});
var _getClientApplicationInsightsConfig = require("./getClientApplicationInsightsConfig");
Object.keys(_getClientApplicationInsightsConfig).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getClientApplicationInsightsConfig[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getClientApplicationInsightsConfig[key];
    }
  });
});
var _isServerApplicationInsightsClient = require("./isServerApplicationInsightsClient");
Object.keys(_isServerApplicationInsightsClient).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _isServerApplicationInsightsClient[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _isServerApplicationInsightsClient[key];
    }
  });
});
var _ServerApplicationInsights = require("./ServerApplicationInsights");
Object.keys(_ServerApplicationInsights).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ServerApplicationInsights[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ServerApplicationInsights[key];
    }
  });
});
var _applicationInsightsConfigSchema = require("./applicationInsightsConfigSchema");
Object.keys(_applicationInsightsConfigSchema).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _applicationInsightsConfigSchema[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _applicationInsightsConfigSchema[key];
    }
  });
});
//# sourceMappingURL=index.js.map